import script from "./UserInputQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInputQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./UserInputQuestion.vue?vue&type=style&index=0&id=c566f5dc&lang=css"

const __exports__ = script;

export default __exports__